export default __webpack_public_path__ + "static/media/_sdg17.e5d76631.png";